import i18n from "../i18n/i18n";

export const isRu = i18n.language === "ru";